const toWatchlistRef = ({ id, listType }) => ({ id, listType })

/**
 * Builds the update payload by comparing the original list state from
 * `watchlist.hasContent` with the user's current selected list ids
 *
 * Only changed lists are sent:
 * - addTo: lists that did not have the content before, but are now selected
 * - removeFrom: lists that had the content before, but are now unselected
 *
 * @param {string} contentItemId
 * @param {Array<{id: string, listType: string, hasContent: boolean}>} initialWatchlists
 * @param {string[]} selectedIds
 * @returns {{
 *   contentItemId: string,
 *   addTo: Array<{id: string, listType: string}>,
 *   removeFrom: Array<{id: string, listType: string}>
 * }}
 */
export const buildWatchlistUpdateInput = (contentItemId, initialWatchlists, selectedIds) => {
  const selectedIdSet = new Set(selectedIds)

  return {
    contentItemId,
    addTo: initialWatchlists
      .filter(watchlist => !watchlist.hasContent && selectedIdSet.has(watchlist.id))
      .map(toWatchlistRef),
    removeFrom: initialWatchlists
      .filter(watchlist => watchlist.hasContent && !selectedIdSet.has(watchlist.id))
      .map(toWatchlistRef)
  }
}
